export const timeTabs = ['今天', '昨天', '近7天']
